






































































































































































/* eslint-disable */
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

import CalculadoraVuex from '@/store/CalculadoraVuex'


@Component

export default class ComponentCalculadoraProcedimento extends Vue {
  @Prop(Number) index
  @Prop(Object) procedimento
  @Prop(Object) calculadora

  @Emit('change')
  change() { }

  @Emit('deleteProcedimento')
  deleteProcedimento(indexProcedimento) {}

  showDetail: Boolean = false

  getCurrency(value) {
    return (this.$options as any).filters.currency(value)
  }

    get ativarTabelaCBHPM() {
      return CalculadoraVuex.getters.ATIVAR_VALORES_TABELA_CBHPM
    }

  formatMaskMoney() {
     this.procedimento.valorBaseProcedimento = this.procedimento.valorBaseProcedimento.replace(/^\$?\d+((,\d{3})+)?(\.\d+)?$/, ".$1,$2")
  }
}
